export { BadgeComponent } from './badge.component';
export { BadgeColor, BadgeColors, BadgeOptions } from './types';
